module.exports = __webpack_public_path__ + "img/3.3bafc6f4.svg";